export default {
  props: {
    areaStyle: {
      type: [String, Object, Array],
      default: () => []
    },
    areaClass: {
      default: ''
    }
  },
  components: {},
  data() {
    return {};
  },
  computed: {},
  methods: {},
  created() {},
  mounted() {},
  beforeUnmount() {},
  watch: {}
};